import request from "@/utils/request";
import qs from "qs";

export interface IPosDashboard {
  type: number;
  providerType: "QUICK_SIGHT" | "EXPLO" | "OMNI";
  dashboardName: string;
  exploDashboardId: string | null;
  omniDashboardId: string | null;
}

/**
 * Get the POS dashboards assigned to the group that the user's role can see.
 * Postman: `GET_group_dashboard_list`
 */
export async function fetchPosDashboards(
  groupId: number | null
): Promise<IPosDashboard[]> {
  const response = await request({
    url: `/group/${groupId}/dashboard?isb2b=0`,
    method: "get",
  });

  return response.data.data.list;
}

/**
 * Get the signed Omni embed URL of a dashboard. The backend picks the copy
 * translated in the given locale.
 * Postman: `GET_omni_embed_url`
 */
export async function fetchOmniEmbedUrl(params: {
  groupId: number | null;
  dashboardId: string;
  locale: string;
}): Promise<string | null> {
  const { groupId, dashboardId, locale } = params;

  const response = await request({
    url: `/v2/group/${groupId}/omni/embed-url?${qs.stringify({
      dashboardId,
      locale,
    })}`,
    method: "get",
  });

  return response.data.data.embedUrl;
}
